import React, { useEffect, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Image } from "@onair/minimal-ui/image";
import { useStoreLibrary } from "@onair/store/library";
import { Stack } from "@mui/material";
import CloseCircleButton from "@onair/ui/button/close-circle-button";
import { cn } from "@onair/utils/cn";
import { GetResourceResponseDto } from "@onair/repositories";

export interface ThumbnailUploaderProps {
	showTitle?: boolean;
	title?: string;
	required?: boolean;
	value?: string;
	note: React.ReactNode;
	onSelect?: (url: string, resource: GetResourceResponseDto) => void;
	onRemove?: () => void;
	className?: string;
	error?: string;
}

const ThumbnailUploader: React.FC<ThumbnailUploaderProps> = (props) => {
	const {
		showTitle = true,
		title = "Hình ảnh",
		required,
		value,
		className,
		note,
		error,
		onSelect,
		onRemove,
	} = props;
	const [previewImage, setPreviewImage] = useState<string>();
	const openResource = useStoreLibrary((state) => state.onOpenResource);
	const handleOpenResouce = () => {
		openResource?.({
			isMultiple: false,
			onSelection(items) {
				if (!items[0].linkUrl) return;

				onSelect?.(items[0]?.linkUrl, items[0]);
				if (!onSelect) {
					setPreviewImage(items[0].linkUrl ?? undefined);
				}
			},
		});
	};
	useEffect(() => {
		setPreviewImage(value);
	}, [value]);
	return (
		<Box component="div" className={cn(className)}>
			{showTitle && (
				<Typography variant="subtitle1" gutterBottom>
					{title}
					{required && <span className="text-[#F04438]">*</span>}
				</Typography>
			)}
			{note && (
				<Box className="flex justify-between mb-1">
					<Stack className="flex-row gap-2 items-center">{note}</Stack>
				</Box>
			)}
			<Box
				className={cn(
					"relative flex p-1 border border-dashed rounded-lg flex-col items-center w-full h-auto aspect-video",
					{
						"border-red-500 mb-2 !bg-red-50": !!error,
						"bg-grey-100": !error,
					},
				)}
			>
				{previewImage ? (
					<>
						<Image
							loading="lazy"
							src={previewImage}
							alt={"thumbnail"}
							className="rounded-lg w-full h-auto aspect-video"
						/>
						<CloseCircleButton
							onClick={() => onRemove?.()}
							className="absolute top-3 right-3"
						/>
					</>
				) : (
					<Stack
						onClick={handleOpenResouce}
						className="items-center w-full h-full justify-center cursor-pointer my-auto"
					>
						<Image
							loading="lazy"
							src="/assets/icons/online-course/ic-upload-image.svg"
							alt="Image Upload Icon"
						/>
						<Button
							variant="contained"
							color="primary"
							startIcon={<CloudUploadIcon />}
						>
							Tải hình
						</Button>
					</Stack>
				)}
			</Box>
			{error ? (
				<Typography className="text-xs text-red-500">{error}</Typography>
			) : null}
		</Box>
	);
};

export default ThumbnailUploader;
